/* =========================================================
   VELMORA — Product recommendations loader
   Fetches Shopify's native recommendations and swaps the
   server-rendered section markup in. No product data in JS.
   ========================================================= */
(function () {
  "use strict";

  function load(container) {
    var url = container.getAttribute("data-url");
    if (!url) return;

    fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error("recommendations unavailable");
        return res.text();
      })
      .then(function (text) {
        var parsed = document.createElement("div");
        parsed.innerHTML = text;
        var fresh = parsed.querySelector("#product-recommendations");
        if (fresh && fresh.innerHTML.trim().length > 0) {
          container.innerHTML = fresh.innerHTML;
          document.dispatchEvent(new CustomEvent("velmora:content-updated"));
        } else {
          container.hidden = true;
        }
      })
      .catch(function () {
        container.hidden = true;
      });
  }

  function init() {
    document.querySelectorAll("[data-recommendations]").forEach(load);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
})();
